export const homeViewList = {
    ALL: "Vue d'ensemble",
    PROJET: "Projets"
}